export default __webpack_public_path__ + "static/media/Vazir-Black.0bbd080f.woff";